import ImageNotFound from "../../assets/enmascarar-detail.png";
import { useConvocatoriaImage } from "../../hooks/useConvocatoriaImage";

interface IProps {
  portadaUrl?: string;
  /** Para nombrar la imagen a quien no ve la pantalla. */
  nombre?: string;
}

/**
 * La portada de la convocatoria, en pequeño, para la fila de la tabla.
 *
 * Es la misma imagen de la tarjeta y se trae igual, una petición por
 * convocatoria. La tabla muestra las mismas que mostraban las tarjetas, así
 * que no pide más de lo que ya se pedía.
 */
export const MiniaturaConvocatoria = ({ portadaUrl, nombre }: IProps) => {
  const { dataImg, loading } = useConvocatoriaImage(portadaUrl);

  // Un hueco del mismo tamaño mientras llega, para que la fila no salte.
  if (loading) {
    return (
      <div
        style={{ width: 72, height: 48, background: "#F0F0F0", borderRadius: 4 }}
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      src={dataImg ? dataImg : ImageNotFound}
      alt={nombre ? `Portada de ${nombre}` : "Portada de la convocatoria"}
      width={72}
      height={48}
      style={{ objectFit: "cover", borderRadius: 4, display: "block" }}
    />
  );
};
